import React from "react";
import get from "lodash/get";
import { useTranslation } from "react-i18next";

import { useGetWorkSpaceRnBankRatingQuery } from "~/schemas/generated/graphql";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";
import { DATA_STATUS_TYPES } from "~/constans/statuses";

import PanelWrapper from "~/components/PanelWrapper";

import s from "./BlockRnBank.less";
import { getParseISO } from "~/libs/getDateOptions";

const MainBlockRnBank = () => {
  const { t } = useTranslation();
  const currentDealerId = useCurrentDealerId();

  const { data, loading } = useGetWorkSpaceRnBankRatingQuery({
    variables: {
      DealerId: currentDealerId,
    },
    fetchPolicy: "cache-and-network",
  });

  const dealerRnBank = get(data, "WorkSpaceGetter.getRnBankRating", []);

  const result = dealerRnBank.sort((a, b) =>
    a.createdAt < b.createdAt ? 1 : -1
  );

  const newResult = get(result, "[0]", []);

  const createdAt = data?.WorkSpaceGetter.getRnBankRating[0]?.createdAt;
  const [formattedMonth, formattedYear] = createdAt
    ? [
        getParseISO({ date: createdAt, atr: "MM" }),
        getParseISO({ date: createdAt, atr: "yy" }),
      ]
    : ["", ""];
  return (
    <PanelWrapper
      width={120}
      height={70}
      label={t("dealers.fin_category")}
      customClassName={s.s_label_bank}
      loading={loading}
    >
      <div className={s.rating}>
        <div className={s.rating_text}>
          {!!newResult.stringValue ? (
            <small>{`${newResult.stringValue} (${formattedMonth}/${formattedYear})`}</small>
          ) : (
            DATA_STATUS_TYPES.ND
          )}
        </div>
      </div>
    </PanelWrapper>
  );
};

export default MainBlockRnBank;
